export const closeWindow = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
}